import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class associatesPartner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Associates Partners
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="Associates_Partners_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Partners</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                Our Associates and Partners
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40">
                                <div className="col-md-12">
                                    <div className="container">
                                        <div
                                            className="row gutter-24"
                                            data-aos="fade-up"
                                            data-aos-delay={200}
                                        >
                                            <div className="col-lg-12 col-sm-12">
                                                <div className="vertical_tab">
                                                    <div className="content">
                                                        <input
                                                            type="radio"
                                                            name="slider"
                                                            defaultChecked=""
                                                            id="home"
                                                        />
                                                        <input type="radio" name="slider" id="blog" />
                                                        <input type="radio" name="slider" id="help" />
                                                        <input type="radio" name="slider" id="code" />
                                                        <div className="list">
                                                            <label htmlFor="home" className="home">
                                                                <span>Media</span>
                                                            </label>
                                                            <label htmlFor="blog" className="blog">
                                                                <span>Knowledge</span>
                                                            </label>
                                                            <label htmlFor="help" className="help">
                                                                <span>Supporting Association</span>
                                                            </label>
                                                            <div className="slider" />
                                                        </div>
                                                        <div className="text-content">
                                                            <div className="home text">
                                                                <div className="title">Media Partners</div>
                                                                <div className="img_content">
                                                                    <img
                                                                        src="assets/img/Coming_soon_banner3.png"
                                                                        alt="LMW image"
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                                {/* <div class="row">
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Bangladesh-Textile.jpg" alt="img"  loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Communion-Media-Partner.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/DFU-Publications--Media-Partner.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Fashion-Era.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/FIbre2fashion.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Indian_Textile_Journal_Media_Partner.jpg" alt="img"  loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Knit-World-Media-Partner.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/MIJ_Textilia.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/MP_ADITYA_MEDIA.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/mp-trade4-india.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Spinning_textiles.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/spry_media.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Tecoya_Trend.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Textil.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Textile_Trends.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Partners/Textile_value_chain.jpg" alt="img" loading="lazy">
                                                      </div>
                                                  </div>
                                              </div> */}
                                                            </div>
                                                            <div className="blog text">
                                                                <div className="title">Knowledge Partners</div>
                                                                <div className="img_content">
                                                                    <img
                                                                        src="assets/img/Coming_soon_banner3.png"
                                                                        alt="LMW image"
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                                {/* <div class="row">
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Knowledge_partners/DKTE.jpg" alt="silver-sponsor image" loading="lazy" />
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Knowledge_partners/sasmira-logo.jpg" alt="LMW image" loading="lazy" />
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Knowledge_partners/Suvin.jpg" alt="LMW image" loading="lazy" />
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Knowledge_partners/VJTI.jpg" alt="LMW image" loading="lazy" />
                                                      </div>
                                                  </div>
                                                  <div class="col-md-3 col-sm-4 col-6">
                                                      <div class="img_content">
                                                          <img src="assets/img/Knowledge_partners/nift-logo.jpg" alt="LMW image" loading="lazy" />
                                                      </div>
                                                  </div>
                                              </div> */}
                                                            </div>
                                                            <div className="help text">
                                                                <div className="title">Supporting Association</div>
                                                                <div className="row">
                                                                    <div className="col-md-3 col-sm-4 col-6">
                                                                        <div className="img_content">
                                                                            <img
                                                                                src="assets/img/Partners/bureau-of-indian-standards.jpg"
                                                                                alt="silver-sponsor image"
                                                                                loading="lazy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-4 col-6">
                                                                        <div className="img_content">
                                                                            <img
                                                                                src="assets/img/Partners/confederation-of-indian-textile-industry.jpg"
                                                                                alt="LMW image"
                                                                                loading="lazy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-4 col-6">
                                                                        <div className="img_content">
                                                                            <img
                                                                                src="assets/img/Partners/Indian-Textile-accessories-&-machinery-manufacturers-assocciation.jpg"
                                                                                alt="LMW image"
                                                                                loading="lazy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-4 col-6">
                                                                        <div className="img_content">
                                                                            <img
                                                                                src="assets/img/Partners/itamma.jpg"
                                                                                alt="LMW image"
                                                                                loading="lazy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-4 col-6">
                                                                        <div className="img_content">
                                                                            <img
                                                                                src="assets/img/Partners/the-textile-association-india.jpg"
                                                                                alt="LMW image"
                                                                                loading="lazy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3 col-sm-4 col-6">
                                                                        <div className="img_content">
                                                                            <img
                                                                                src="assets/img/Partners/aacc.jpg"
                                                                                alt="LMW image"
                                                                                loading="lazy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="horizon_tab">
                                                                <div className="content">
                                                                    <label htmlFor="home" className="home active">
                                                                        <span>01</span>
                                                                    </label>
                                                                    <label htmlFor="blog" className="blog">
                                                                        <span>02</span>
                                                                    </label>
                                                                    <label htmlFor="help" className="help">
                                                                        <span>03</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(associatesPartner));